export interface IBioSaveStrength {
  id?: string;
  name: string;
  proficiency?: string;
  additionalInfo?: string;
  relatedExperiences: string[];
  pin?: boolean;
  context: string;
  locale: string;
}

export interface IBioStrength {
  id: string;
  name: string;
  code: number;
  weight: number;
}

export class BioStrength {
  public id: string;
  public name: string;
  public code: number;
  public weight: number;

  constructor(data: IBioStrength) {
    this.id = data.id;
    this.name = data.name;
    this.code = data.code;
    this.weight = data.weight;
  }
}
